require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/pricing.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/pricing.legacy.js
// module id = 632
// module chunks = 31